import { useTranslations } from 'next-intl';
import styles from './SectionEmptyState.module.css';

/* Empty state for the /science listing sections.
 *
 * Shown when a section has no CMS entries at all (the per-filter
 * "no results" message inside each section is separate). Reads as a
 * lab placeholder: hairline dashed frame on the section surface, a
 * mono eyebrow with a blinking terminal caret — the same data-readout
 * voice as the section counts — and one quiet Graphik line.
 *
 * `tone` follows the section surface: 'dark' on the #0a0a0a byte
 * surfaces, 'light' on the #f5f5f5 paper/publication strip. */

interface Props {
  tone?: 'dark' | 'light';
  eyebrow?: string;
  message: string;
}

const SectionEmptyState = ({ tone = 'light', eyebrow, message }: Props) => {
  const t = useTranslations('science');
  return (
    <div className={styles.panel} data-tone={tone} role="status">
      <p className={styles.eyebrow} data-tone={tone}>
        {eyebrow ?? t('science.empty.eyebrow')}
        <span className={styles.caret} aria-hidden="true">
          ▍
        </span>
      </p>
      <p className={styles.message} data-tone={tone}>
        {message}
      </p>
    </div>
  );
};

export default SectionEmptyState;
